

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  wrapper: function wrapper(props) {return {
      position: 'relative',
      font: {
        family: ['Lato', 'sans-serif']
      },
      width: props.width || '25rem'
    };},
  fieldWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  descriptionWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  description: {
    cursor: 'default',
    display: 'block',
    alignItems: 'flex-end',
    textOverflow: 'clip',
    overflowWrap: 'break-word',
    margin: { top: 0, bottom: '0.4rem' },
    letterSpacing: '0.02rem',
    color: colors.neutral[600],
    '&:focus': {
      outline: 'none'
    }
  },
  label: {
    color: colors.neutral[900],
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500
    },
    letterSpacing: '0.02rem',
    marginBottom: '0.4rem'
  },
  textArea: function textArea(props) {return {
      width: '100%',
      height: props.height || '10rem',

      resize: 'none',
      borderRadius: '6px',
      boxSizing: 'border-box',
      color: colors.neutral[900],
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem',
        family: 'inherit'
      },
      letterSpacing: '0.02rem',
      padding: '0.8rem',

      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: colors.neutral[500]
      }
    };},
  textAreaDisabled: {
    cursor: 'not-allowed'
  },
  textAreaGuideline: {
    maxWidth: '100%'
  },
  textAreaValidationTrue: {
    border: ['0.1rem', 'solid', colors.neutral[200]],

    '&:focus': {
      border: ['0.1rem', 'solid', colors.blue[500]],
      caretColor: colors.blue[500]
    }
  },
  textAreaValidationFalse: function textAreaValidationFalse(props) {return {
      border:
      props.value === '' ?
      ['0.1rem', 'solid', colors.blue[300]] :
      ['0.1rem', 'solid', colors.red[500]]
    };}
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map